import type { $ } from "../dom";
import { _rk } from "./rk-strings";

export type NubOptions = {
  name: string;

  type?: "any" | "single" | "multiple";
};

export class Nub {
  readonly name: string;
  readonly id: number;
  readonly $root: $;

  private static globalId: Record<string, number> = {};

  constructor($root: $, options: NubOptions) {
    const { name } = options;

    this.$root = $root;

    if (options.type === "single") {
      if (this.$root.length !== 1) {
        console.warn(
          "Element is empty or is non-single (should be unique)",
          this.$root,
        );
      }
    } else if (options.type === "multiple") {
      if (this.$root.length === 0) {
        console.warn(
          "Element is empty (should contain at least one element)",
          this.$root,
        );
      }
    }

    this.name = _rk(name);

    Nub.globalId[this.name] ??= 0;

    this.id = Nub.globalId[this.name]++;
  }
}
